import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
    Col,
    Row,
    Container,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    ButtonDropdown,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    Label,
    Badge,
    FormText,
    Card,
    CardTitle,
    CardBody,
    options
} from "reactstrap";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import mock from "../tables/mock";
import Widget from "../../components/Widget/Widget.js";
import s from "../tables/Tables.module.scss";
import moreIcon from "../../assets/tables/moreIcon.svg";
import Starrating from "../../assets/tables/Start.png";
import { useHistory, useParams } from 'react-router-dom';
import { MultiSelect } from "react-multi-select-component";
import { CFormSwitch } from '@coreui/react';
// import mobilegif from "../../assets/tables/mobile.gif";
import "../dashboard/Dashboard.css"

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../styles/tost.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import BaseAPI from '../../api/apiurl.js';




const Useredit = function () {
    const [selectedDate, setSelectedDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [staff, setStaff] = useState('');
    const [designation, setDesignation] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [imeNo, setImeNo] = useState('');
    const [email, setEmail] = useState('');
    const [staffName, setStaffName] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const { id } = useParams(); // 
    const [customerId, setCustomerId] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedValueModule, setSelectedValueModule] = useState([]);
    const [viewValueModule, setViewValueModule] = useState(null); // module view
    const [selectedValueProjectview, setSelectedValueProjectview] = useState([]); //project view
    const [entityOptions, setEntityOptions] = useState([]); // project droupdown
    const [selectedValueproject, setSelectedValueproject] = useState([]);
    const [sendmodule, setSendmodule] = useState([]);
    const [sendProject, setProject] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [mobile, setMobile] = useState([]);
    const [domainName, setDomainName] = useState('');
    const [showPassword, setShowPassword] = useState(false); // show password




    const history = useHistory();

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleDateChange2 = (date) => {
        setEndDate(date);
    };

    const options = [
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' }

    ]

    const optionsmodule = [
        { value: 'service', label: 'Service' },
        { value: 'project', label: 'Project' }
    ];


    const buttonstyle = {
        display: 'flex',
        alignItems: 'center',
    };

    const handleClickUserview = () => {
        history.push('/timeinlive/User');
    };


    const [firstTable] = useState(mock.firstTable);
    const [secondTable] = useState(mock.secondTable);
    const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
    const [tableDropdownOpen, setTableMenuOpen] = useState(false); //

    const pageSize = 10;
    const secondTablePagesCount = Math.ceil(secondTable.length / pageSize);



    const setSecondTablePage = (e, index) => {
        e.preventDefault();
        setSecondTableCurrentPage(index);
    }

    const tableMenuOpen = () => {
        setTableMenuOpen(!tableDropdownOpen);
    } //

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption.value);
    };

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };
    //   const handleChangeModule = (selectedOptionmodule) => {
    //     setSelectedValueModule(selectedOptionmodule.value);
    //   };

    const handlePasswordToggle = () => {
        setShowPassword(!showPassword);
    };

    const fetchEntityOptions = async () => {
        try {
            const url = `${BaseAPI}project`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // You might need to add other headers if required (e.g., authorization headers)
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }

            const data = await response.json();
            setEntityOptions(data.data.map(item => ({ label: item.entityname, value: item.id })));
        } catch (error) {
            console.error('Error:', error);
            // Handle the error here if needed  
        }
    };



    useEffect(() => {
        fetchData();
        const customerId = localStorage.getItem('customerid');
        const companyId = localStorage.getItem('companyid');
        if (customerId) {
            setCustomerId(customerId);
        }
        if (companyId) {
            setCompanyId(companyId);
        }
        fetchEntityOptions();
    }, []);

    useEffect(() => {
        // Fetch the domain name from local storage
        const storedDomain = localStorage.getItem('domain');
        if (storedDomain) {
            setDomainName(storedDomain);
        }
    }, []);

    console.log("valu localStorage", customerId, companyId)

    const fetchData = async () => {
        try {
            const response = await fetch(`${BaseAPI}staffedit/${id}`); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const data = await response.json();
            console.log('Fetched data:', data);
            // Populate the form fields with the fetched data

            setStaff(data.data.staff[0].staff_id);
            setDesignation(data.data.staff[0].designation);
            setUserName(data.data.staff[0].username);
            setPassword(data.data.staff[0].password);
            setMobileNo(data.data.staff[0].mobileno);
            setImeNo(data.data.staff[0].imeino);
            setEmail(data.data.staff[0].email);
            setStaffName(data.data.staff[0].name);
            setSelectedValue(data.data.staff[0].account);
            setViewValueModule(data.data.staff[0].modules);
            const entityNames = data.data.staff[0].projectid.map(project => project.entityname);
            const commaSeparatedEntityNames = entityNames.join(', ');
            setSelectedValueProjectview(commaSeparatedEntityNames);
            setSendmodule(data.data.staff[0].modules);
            setProject(data.data.staff[0].projectid[0].id);
            const mobileValue = data.data.staff[0].regapproval === 1;
            setIsChecked(mobileValue);
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle error...
        }

    };


    console.log('modeules:', viewValueModule);
    console.log('project:', selectedValueProjectview);
    const handleSubmit = async () => {
        setSubmitted(true);
        try {
            const url = `${BaseAPI}staffupdate/${id}`;
            const params = {
                staff: staff,
                designation: designation,
                user_name: `${userName}@${domainName}`,
                password: password,
                mobile_no: mobileNo,
                ime_no: imeNo,
                email: email,
                staffname: staffName,
                company_id: companyId,
                customer_id: customerId,
                account: selectedValue,
                modules: selectedValuesString || viewValueModule,
                project_id: selectedProjectString || sendProject,
                regapproval: isChecked ? 1 : 0
            };

            const response = await fetch(`${url}?${new URLSearchParams(params)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const data = await response.json();
            setResponseMessage(data.message);
            toast.success('Data Updated Successful!', {
                autoClose: 1500,
                position: 'top-center',
                className: 'custom-toast-success', // Apply the custom error class

            });
            await new Promise((resolve) => setTimeout(resolve, 1500));

            // Navigate to the desired route
            history.push('/timeinlive/user');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Sorry Data Not Added', {
                autoClose: 1500,
                position: 'top-center',
                className: 'custom-toast-error', // Apply the custom error class
            });
            setResponseMessage('Error occurred while making the API request.');
        }
    };
    const selectedValues = selectedValueModule.map(option => option.value);
    const selectedValuesString = selectedValues.join(', ');

    const selectedProject = selectedValueproject.map(option => option.value);
    const selectedProjectString = selectedProject.join(', ');

    const [isPlaceholderVisible, setPlaceholderVisible] = useState(true);

    // const handleMultiSelectChange = (selected) => {
    //     setSelectedValueModule(selected);
    //     setPlaceholderVisible(selected.length === 0);
    // };


    return (

        <Container fluid>
             <br></br> <br></br>
            <Card >
                <CardBody style={{ whiteSpace: 'nowrap' }}>
                    <div className="row mt-6">
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">User ID</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="staffId" placeholder="Enter the User Id" value={staff} onChange={(e) => setStaff(e.target.value)} disabled />
                                    {submitted && staff === '' && (
                                        <FormText color="danger">Please enter the User ID</FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Email</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="email" placeholder="Enter the Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    {submitted && email === '' && (
                                        <FormText color="danger">Please enter the Email</FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Password</label>
                                <div className="col-sm-10 input-group">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <span
                                            onClick={handlePasswordToggle}
                                            className={`password-toggle input-group-text ${showPassword ? 'show' : 'hide'}`}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                                        </span>
                                    </div>
                                </div>
                                {submitted && password === '' && (
                                    <FormText color="danger">Please enter the password</FormText>
                                )}
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Choose Projects   <span className="required" style={{ color: 'red' }}>*</span> </label>
                                <div className="col-sm-10">

                                    <Select
                                        isMulti
                                        placeholder={selectedValueProjectview}
                                        className="select2-selection"
                                        options={entityOptions}
                                        defaultValue={selectedValueproject || sendProject}
                                        onChange={setSelectedValueproject}
                                    />
                                    {/* <MultiSelect
                                        className="select2-selection"
                                        options={selectedValueProject}
                                        value={selectedValueProject}
                                        // onChange={setSelectedValueProject}

                                    /> */}

                                    {/* <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        id="Chooseprojects"
                                        title="Asset Form"
                                    // options={options}

                                    /> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Name</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="staffname" placeholder="Enter the Name" value={staffName} onChange={(e) => setStaffName(e.target.value)} />
                                    {submitted && staffName === '' && (
                                        <FormText color="danger">Please Enter the Name </FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select Role <span className="required" style={{ color: 'red' }}>*</span></label>
                                <div className="col-sm-10">
                                    <Select
                                        classNamePrefix="select2-selection"
                                        placeholder={selectedValue}
                                        id="selectedValue"
                                        title="Asset Form"
                                        options={options}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Mobile Number</label>
                                <div className="col-sm-10">

                                    <input type="text" className="form-control" id="mobile_no" placeholder="Enter the Mobile Number" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} />
                                    {submitted && mobileNo === '' && (
                                        <FormText color="danger">Please Enter the Mobile Number</FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Choose Modules<span className="required" style={{ color: 'red' }}>*</span></label>
                                <div className="col-sm-10">
                                    <Select
                                        isMulti
                                        className="select2-selection"
                                        placeholder={viewValueModule}
                                        options={optionsmodule}
                                        value={selectedValueModule || viewValueModule}
                                        onChange={setSelectedValueModule}

                                    />
                                    {/* <Select
                                        classNamePrefix="select2-selection"
                                        placeholder= {selectedValueModule}
                                        id="selectedValueModule"
                                        title="Asset Form"
                                        options={optionsmodule}
                                        onChange={handleChangeModule}
                                    /> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Designation</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="designation" placeholder="Enter the Designation" value={designation} onChange={(e) => setDesignation(e.target.value)} />
                                    {submitted && designation === '' && (
                                        <FormText color="danger">Please Enter the Designation</FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">User Name</label>
                                <div className="col-sm-10 input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputPassword"  
                                        placeholder="Enter the User Name"
                                        value={`${userName}`}
                                        onChange={(e) => setUserName(e.target.value)}
                                        disabled
                                    />
                                    <div className="input-group-append">
                                        <span className="password-toggle input-group-text" >@{domainName}</span>
                                    </div>
                                </div>
                                {submitted && userName === '' && (
                                    <FormText color="danger">Please Enter the User Name</FormText>
                                )}
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">UID Number</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="ime_no" placeholder="Enter the UID Number" value={imeNo} onChange={(e) => setImeNo(e.target.value)} />
                                </div>
                            </div>
                            <div className="mb-4 row flex-column">
                                <div className="col-sm-10">
                                    <label htmlFor="custom-switch" className="custom-switch-label" style={{ marginRight: '20px' }}>
                                        Mobile Access
                                    </label>
                                    <label className="custom-switch">
                                        <input
                                            type="checkbox"
                                            id="custom-switch"
                                            className="custom-switch-input"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                        />
                                        <span className="custom-switch-slider" />
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button type="button" onClick={handleClickUserview} className="btn btn-primary" style={{ padding: "5px 20px" }}> <i className="fa fa-window-close" style={{ fontSize: "16px" }} />&nbsp; Cancel</button> &nbsp;&nbsp;
                        <button type="button" className="btn btn-primary" style={{ padding: "5px 10px", }} onClick={handleSubmit}><i className="fa fa-plus-circle" style={{ fontSize: "16px" }} />&nbsp; Submit</button>
                    </div>


                </CardBody>
            </Card>
            &nbsp;  &nbsp;  &nbsp;
            <div>
            </div>
            <ToastContainer />
        </Container>



    )
}

export default Useredit;
